"use client";

import { useTranslations } from "next-intl";
import type { BlogForClient } from "@/features/blog/shared/types";
import { Link } from "@/i18n/navigation";
import { cn, ScrollArea, ScrollBar, VStack } from "@/ui";
import { BlogItem } from "./BlogItem";

interface BlogSideSectionProps {
  blogPosts: BlogForClient[];
  className?: string;
}

/**
 * BlogSideSection component - Sidebar blog posts list
 */
export const BlogSideSection = ({ blogPosts, className }: BlogSideSectionProps) => {
  const generalT = useTranslations("general");

  return (
    <VStack className={cn("items-center space-x-2 space-y-2 pb-6", className)}>
      <ScrollArea className="rounded-md py-4">
        <VStack className="mr-2 space-y-6">
          {blogPosts.map((post) => (
            <BlogItem
              key={post.id}
              post={post}
            />
          ))}
        </VStack>
        <ScrollBar orientation="horizontal" />
        <ScrollBar orientation="vertical" />
      </ScrollArea>
      <Link
        href="/blog"
        className="btn"
      >
        {generalT("view_all")}
      </Link>
    </VStack>
  );
};
